import { useEffect, useRef } from "react";

export function useClickOutside<T extends HTMLElement>(
	callback: () => void,
	isEnabled = true,
): React.RefObject<T | null> {
	const ref = useRef<T>(null);

	useEffect(() => {
		if (!isEnabled) return;

		const handleClickOutside = (event: MouseEvent) => {
			if (ref.current && !ref?.current?.contains(event.target as Node)) {
				callback();
			}
		};
		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [callback, isEnabled]);

	return ref;
}
